import { registerFr } from '../i18n/index.js';

registerFr({
  'Attach transcript': 'Joindre une transcription',
  'Upload transcript': 'Téléverser la transcription',
  'Uploading…': 'Téléversement…',
  'kB': 'ko',
  'A transcript is a .txt, .vtt or .md file. That one is not.':
    'Une transcription est un fichier .txt, .vtt ou .md. Celui-ci n’en est pas un.',
  'That file is larger than 5 MB. Nothing was sent.':
    'Ce fichier dépasse 5 Mo. Rien n’a été envoyé.',
  'Give the date the meeting was held before attaching its transcript.':
    'Indiquez la date de la séance avant de joindre sa transcription.',
  'The transcript could not be uploaded.': 'La transcription n’a pas pu être téléversée.',
  'Uploading logs the meeting with the transcript as its body — that is the save. A reading then proposes the commitments and the facts it finds; nothing reaches the record without your click.':
    'Le téléversement consigne la séance avec la transcription pour corps — c’est l’enregistrement. Une lecture propose ensuite les engagements et les faits qu’elle y trouve ; rien n’entre au dossier sans votre clic.',
  'Logged as': 'Consigné sous',
  'reading it as run': 'lu par l’exécution',
  'what it finds arrives in Review as proposals.': 'ce qu’elle trouve arrive en revue sous forme de propositions.',
  'the transcript is on the record, but no reading started:':
    'la transcription est au dossier, mais aucune lecture n’a démarré :',
  'the model endpoint did not answer.': 'le point d’accès du modèle n’a pas répondu.',
}, 'TranscriptUpload');
